<template>
  <div class="capacity-report">
    <div class="capacity-report-name">过往经历</div>
    <div class="comparison">
      <div class="name-list">
        <p>对方的过往经历</p>
        <p>我的过往经历</p>
      </div>
      <div class="she box">
        <div class="experience-list">
          <experience-item v-for="(item, index) in comparisonExpReverse" :key="index + 'comparisonExp'" :is-end="index === comparisonExp.length - 1" @on-detail="handleClickDetail($event,'left')" :data="item"></experience-item>
        </div>
      </div>
      <div class="me box">
        <div class="experience-list">
          <experience-item v-for="(item, index) in meExpReverse" :key="index + 'meExp'" :is-end="index === meExp.length - 1" @on-detail="handleClickDetail($event,'right')" :data="item"></experience-item>
        </div>
      </div>
    </div>
    <experience-detail :position="position" v-if="state" :data="companyDetail" :has-time="hasTime"/>
  </div>
</template>

<script>
  import ExperienceItem from "./experience-item";
  import ExperienceDetail from "./experience-detail"
  import api from "../../../api";
  export default {
    name: "capacity-report",
    props:{
      familyName: String,
      meExp: {
        type: Array,
        default: () => []
      },
      comparisonExp: {
        type: Array,
        default: () => []
      }
    },
    components: {ExperienceItem, ExperienceDetail},
    data(){
      return{
        position: 'left',
        state: false,
        companyDetail: {},
        hasTime: true,
        isLoading: false
      }
    },
    computed:{
      meExpReverse(){
        return JSON.parse(JSON.stringify(this.meExp)).reverse()
      },
      comparisonExpReverse(){
        return JSON.parse(JSON.stringify(this.comparisonExp)).reverse()
      }
    },
    methods: {
      handleClickDetail(name, position){
        if(this.isLoading) return;
        this.isLoading = true
        this.position = position
        api.planning.getCompanyDetail({company_name: name}).then(res=>{
          this.isLoading = false
          if(res.code === 1000){
            this.companyDetail = res.data
            this.state = true
            this.hasTime = true
          }else if(res.code === 20263 || res.code === 201201 || res.code === 2012){
            this.companyDetail = {company_name: name}
            this.state = true
            this.hasTime = false
          }else {
            this.$message(res.message)
          }
        }).catch(err=>{
          this.isLoading = false
        })
      }
    },
    mounted() {
      document.addEventListener("click", _=>{
        this.state = false
      })
    }
  }
</script>

<style scoped lang="scss">
.capacity-report{
  margin-bottom: 50px;
  position: relative;
  .capacity-report-name{
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    margin-bottom: 34px;
  }
  .comparison{
    width: 1200px;
    height: 541px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-size: 100%;
    background-image: url("https://files.wondercv.com/PC/editor/planning/people/bgcard3.png");
    padding: 24px 32px 37px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .name-list{
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 22px;
      &>p{
        width: 552px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
      }
    }
    & > .box{
      width: 552px;
      height: 406px;
      background: #252830;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 28px 60px 20px;
      .experience-list{
        width: 100%;
        height: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar{
          display: none;
        }
      }
    }
  }
}
</style>
